'use client';

import dynamic from 'next/dynamic';

const BackdropFilterDemo = dynamic(() => import('./index'));

export default BackdropFilterDemo;
